const data = [
  "adaptive_logo", //Hide 'charts byTradingView' text on small screens
  "dont_show_boolean_study_arguments", //Whether to hide indicator parameters
  "hide_last_na_study_output", //Hide the last indicator output
  "move_logo_to_main_pane", //logo in the middle
  "same_data_requery", //Allows you to call setSymbol with the same symbol to refresh the data
  "hide_left_toolbar_by_defaul", //Hide the left toolbar when opening the chart for the first time
  "side_toolbar_in_fullscreen_mode", //With this feature you can enable the drawing toolbar in full screen mode
  // "disable_resolution_rebuild", //The displayed time is consistent with the obtained data time
  "seconds_resolution", //Supports cycles in seconds
  // "hide_last_na_study_output", // hide behind the indicator n/a
];

export default data;
